import { t } from '../../../i18next';
import { isEmpty } from '../../../shared/utils';

export function resolvePostSaveRoutingMessage({
  changedRows,
}: {
  changedRows: Array<Record<string, unknown>>;
}): string | null {
  if (!changedRows.length) {
    return null;
  }

  const hasMissingRoutingFields = changedRows.some(
    (row) => !isEmpty(row?.mat_ident_nr) && isEmpty(row?.plangruppe) && isEmpty(row?.pgz),
  );

  if (hasMissingRoutingFields) {
    return t('npiSteering.routing_group_or_counter_not_defined');
  }

  return null;
}
